import {imageApi} from "../../../../lib/api/wineMenuApi";
import {AxiosResponse} from "axios";
import {UploadedImage} from "@sobr/wine-menu-client";

export type ImageCollection = 'filler' | 'cover' | 'wine';
const baseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

export function getPredefinedImageCollection(collection: ImageCollection): string[] {
    return imageCollections[collection].map(img => baseUrl + img);
}

export async function fetchUserImages(userId: string, collection: string): Promise<string[]> {
    const apiResponse: AxiosResponse<UploadedImage[]> = await imageApi.listImagesForUser({
        userId: userId,
        collection: collection
    });
    return apiResponse.data.map(i => i.url);
}

export interface FetchImageCollection {
    userId: string
    collection: ImageCollection
}

export interface ImageGroup {
    name: string
    images: string[]
}

export async function fetchImageCollection(req: FetchImageCollection): Promise<ImageGroup[]> {
    const userImages = await fetchUserImages(req.userId, req.collection);
    const predefined = getPredefinedImageCollection(req.collection);
    return [
        {
            name: "Eigene Bilder",
            images: userImages
        },
        {
            name: "Vorgefertigte Bilder",
            images: predefined
        }
    ];
}

const imageCollections = {
    wine: [],
    filler: [
        '/images/filler/cork1.jpg',
        '/images/filler/cork2.jpg',
        '/images/filler/wineglass-grapes.png',
        '/images/filler/corkscrew.jpg',
        '/images/filler/corkscrew-stain.jpg',
        '/images/filler/wineglass.jpg',
        '/images/filler/winestain1.jpg',
        '/images/filler/winestain2.jpg',
        '/images/filler/winestain3.jpg'
    ],
    cover: [
        '/images/covers/AdobeStock_154230529.jpg',
        '/images/covers/iStock-183376722.jpg',
        '/images/covers/iStock-155369111.jpg',
        '/images/covers/iStock-157561350.jpg',
        '/images/covers/iStock-175515833.jpg',
        '/images/covers/iStock-177296906.jpg',
        '/images/covers/iStock-177379806.jpg',
        '/images/covers/iStock-179384084.jpg',
        '/images/covers/iStock-185217941.jpg',
        '/images/covers/iStock-185239095.jpg',
        '/images/covers/iStock-471736095.jpg',
        '/images/covers/iStock-612624166.jpg',
        '/images/covers/iStock-823479906.jpg',
        '/images/covers/iStock-879709130.jpg',
        '/images/covers/iStock-928458840.jpg',
        '/images/covers/44248144_xl.jpg',
        '/images/covers/iStock-942774110.jpg',
        '/images/covers/iStock-957120060.jpg',
        '/images/covers/iStock-985617710.jpg',
        '/images/covers/iStock-1054905888.jpg',
        '/images/covers/iStock-1087803910.jpg'
    ]
};